import React from 'react';
import { Layout } from '../components/Layout';
import { graphql } from 'gatsby';
import { get } from '../util/Mappers';
import { PostLink } from '../components/PostLink';

function mapEdges(data) {
  if (data) {
    return data.edges.map(get`node`).map(post => (
      <PostLink {...post} key={post.id} />
    ));
  } else {
    return null;
  }
}

const svg = tag => (
  `<svg xmlns='http://www.w3.org/2000/svg' width='150' height='150' viewBox='0 0 100 100'>
    <text transform='rotate(-45 100 100)' x='40' y='30' fill='lightblue' style='blue; font-weight: bold; font-family: sans-serif;'>
      %23${tag}
    </text>
  </svg>`.replace(/\r?\n/g, '')
    .replace(/</g, '%3C')
    .replace(/>/g, '%3E')
);

const img = tag => (
  <div style={{
    width: '100%',
    height: '100%',
    backgroundImage: `url("data:image/svg+xml,${svg(tag)}")`,
    position: 'absolute',
    backgroundColor: '#222'
  }}/>
);

export default ({ data: { allMarkdownRemark }, pageContext: { tag } }) => (
  <Layout title={`#${tag}`} image={img(tag)}>
    {mapEdges(allMarkdownRemark)}
  </Layout>
);

export const query = graphql`
  query PostsByTagQuery($tag: [String]) {
    allMarkdownRemark(
      filter: {frontmatter: {tags: {in: $tag}, skip: {ne: "yes"}}},
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          id
          html
          excerpt(pruneLength: 250)
          meta: frontmatter {
            title
            tags
            date(formatString: "MMMM DD, YYYY [at] HH:MM")
            thumbnail {
              data: childImageSharp {
                fluid(maxWidth: 2048, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
                fixed(width: 300, height: 300, cropFocus: CENTER, quality: 100) {
                  ...GatsbyImageSharpFixed_noBase64
                }
              }
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
